import { WISE, APM } from '@/views/checkout/payment/helper/constant';

export const apmPaymentType = (paymentMethodName = '', imageFileName) => {
  if (paymentMethodName === WISE) {
    const wisePaymentName = getWisePaymentName(imageFileName);
    return `apm-${wisePaymentName}`;
  }
  return `apm-${paymentMethodName}`;
};

export const getWisePaymentName = (imageFileName) => {
  const wiseSubstr = `${WISE}-`;
  return imageFileName.substring(imageFileName.indexOf(wiseSubstr) + wiseSubstr.length).toLowerCase();
};

export const getApmGaTrackingName = (paymentMethodName, imageFileName) => {
  if (paymentMethodName === WISE) {
    return imageFileName.replace(WISE, APM).toLowerCase()
  }
  return `${APM}-${paymentMethodName}`.toLowerCase()
}
